<template>
    <el-dialog
        class="shipment"
        :visible.sync="redeliverVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="900px"
        title="Reshipment"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div  style="padding:0 0 10px 0"> 
            <div>{{order_sn}}</div>
         </div>
        <el-table
                :data="tableData"
                highlight-current-row
                max-height="300"
                @selection-change="handleSelectionChange"
            >
                <el-table-column
                    label="Sub order No."
                    property="order_sn"
                    align="left"
                    min-width="150"
                >
                </el-table-column>
                <el-table-column
                    label="Tracking NO."
                    property="tracking_number"
                    align="left"
                    min-width="120"
                ></el-table-column>
                <el-table-column
                    label="Status"
                    property="status_cn"
                    align="left"
                ></el-table-column>
                <el-table-column
                    label="Operation time"
                    property="create_time"
                    align="left"
                ></el-table-column>

                <el-empty :image-size="120" slot="empty">
                    <img slot="image" src="@/assets/image/empty-data.svg" />
                </el-empty>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">Close</el-button>
            </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";


export default {

    data() {
        return {
            order_sn: "",
            loading:false,
            tableData:[
            ]
        };
    },
    methods: {
        orderRedeliver() {
            this.loading = true;
            cmofferApi
                .orderRedeliver(
                    {
                        shop_id: this.tableItem.shop_id,
                        plt_order_sn: this.tableItem.plt_order_sn,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.order_sn = res.data.plt_order_sn;
                        this.tableData = res.data.re_orders;
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        closeDialog() {
            //this.$refs["editForm"].clearValidate();
            //this.$refs["editForm"].resetFields();
            this.$emit("update:redeliverVisible", false);
        },

        async initialize() {
            this.orderRedeliver();
        },
    },

    components: {
    },
    props: {
        redeliverVisible: Boolean,
        tableItem:Object,
    },
    watch: {
        redeliverVisible:{
            handler: function(nv, ov) {
                if (nv) {
                    this.initialize();
                }
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.shipment {
    ::v-deep .el-dialog {

        .el-table {
            .col-customized {
                font-size: 18px;
                &.check {
                    color: $color-primary;
                }
            }
        }
    }
}
</style>
